/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { getRequest } from 'apis/ApiInstence';
import axiosInstance from 'apis/axiosConfig';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const EditStartup = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        address: '',
        startupName: '',
        fundingStatus: '',
        website: '',
        program: '',
        description: '',
        year: '',
        state: '',
        logo: null
    });
    const [existingLogo, setExistingLogo] = useState('');
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        const fetchStartup = async () => {
            try {
                const res = await getRequest(`startups/${id}`);
                const data = res?.data;
                if (data) {
                    const user = data.user || {};
                    setFormData({
                        firstName: user.firstName || '',
                        lastName: user.lastName || '',
                        email: user.email || '',
                        mobile: user.mobile || '',
                        address: user.address || '',
                        startupName: data.startupName || '',
                        fundingStatus: data.fundingStatus || '',
                        website: data.website || '',
                        program: data.program || '',
                        description: data.description || '',
                        year: data.year || '',
                        state: data.state || '',
                        logo: null
                    });
                    setExistingLogo(data.logo || '');
                }
            } catch (err) {
                console.error(err);
                toast.error("Failed to load startup details");
            } finally {
                setFetching(false);
            }
        };
        fetchStartup();
    }, [id]);

    const handleChange = (e) => {
        if (e.target.name === 'logo') {
            setFormData({ ...formData, logo: e.target.files[0] });
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const submitData = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key] !== null && formData[key] !== undefined) {
                submitData.append(key, formData[key]);
            }
        });

        try {
            // Using axiosInstance directly for PUT since ApiInstence doesn't have putRequest
            await axiosInstance.put(`/startups/admin/${id}`, submitData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success("Startup profile updated successfully!");
            navigate('/startups');
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Failed to update startup");
        } finally {
            setLoading(false);
        }
    };

    if (fetching) return <div className="text-center mt-5">Loading...</div>;

    return (
        <div className='container-fluid mt-5 mb-5'>
            <div className='mainheadig mx-4 mb-4 d-flex justify-content-between align-items-center'>
                <h4 className='text-white font-weight-bold'>Edit Startup Profile</h4>
                <button className="btn btn-light" onClick={() => navigate(-1)}>Back</button>
            </div>
            <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                <div className='row'>
                    <div className='col-12 mb-3'>
                        <h5 className="border-bottom pb-2">Founder Details</h5>
                    </div>
                    <div className='col-md-12 form-group'>
                        <label className='admin-label font-weight-bold'>Founder Name *</label>
                        <input type='text' name='firstName' className='form-control' value={formData.firstName} onChange={handleChange} placeholder='Enter full name' required />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Mobile Number</label>
                        <input type='text' name='mobile' className='form-control' value={formData.mobile} onChange={handleChange} placeholder='Enter mobile number' />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Email Address</label>
                        <input type='email' name='email' className='form-control' value={formData.email} onChange={handleChange} placeholder='Enter email address' />
                    </div>
                    <div className='col-sm-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Founder Address</label>
                        <input type='text' name='address' className='form-control' value={formData.address} onChange={handleChange} placeholder="e.g. 123 Main St, City" />
                    </div>

                    <div className='col-12 mb-3 mt-4'>
                        <h5 className="border-bottom pb-2">Startup Details</h5>
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Startup Name *</label>
                        <input type='text' name='startupName' className='form-control' value={formData.startupName} onChange={handleChange} required />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Cohort Year (e.g. 2019-2020)</label>
                        <input type='text' name='year' className='form-control' value={formData.year} onChange={handleChange} placeholder="e.g. 2019-2020" />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Program</label>
                        <select name='program' className='form-control' value={formData.program} onChange={handleChange}>
                            <option value="">Select Program</option>
                            <option value="Seed">Seed</option>
                            <option value="Pre Seed">Pre Seed</option>
                            <option value="SOP">SOP</option>
                        </select>
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Incorporation State</label>
                        <input type='text' name='state' className='form-control' value={formData.state} onChange={handleChange} placeholder="e.g. Madhya Pradesh" />
                    </div>
                    <div className='col-md-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Website URL</label>
                        <input type='text' name='website' className='form-control' value={formData.website} onChange={handleChange} placeholder="https://example.com" />
                    </div>
                    
                    <div className='col-sm-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Description</label>
                        <textarea name='description' className='form-control' rows="3" value={formData.description} onChange={handleChange}></textarea>
                    </div>

                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold d-block'>Logo (Leave empty to keep existing)</label>
                        {existingLogo && <img src={`${process.env.REACT_APP_BACKEND}uploads/${existingLogo}`} alt="Current Logo" width="50" className="mb-2 mr-3" style={{borderRadius: '50%'}} />}
                        <input type='file' name='logo' className='form-control-file d-inline-block' onChange={handleChange} accept="image/*" />
                    </div>

                    <div className='col-12 mt-4 text-center'>
                        <button type='submit' className='btn btn-primary px-5 font-weight-bold' disabled={loading}>
                            {loading ? 'Updating...' : 'Update Profile'}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EditStartup;
